import config from 'constants/config'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import { ChertoExperiments } from 'constants/experiments'
import { TWO_TOWERS_INTERACTION_CUTOFF_DAYS } from 'constants/recommendations'
import useExperiment from 'hooks/Experiments/useExperiment'
import { useUserInteractions } from 'hooks/Recommendation/useUserInteractions'
import isBot from 'lib/web/isBot'

export default function useSearchRecommendationsReranking(filters: App.OfferListFilters, disabled: boolean) {
  const enabled = useFeatureFlag(OptimizelyFeatureFlags.lereSearchRerankingEnabled) && config.LERE_ENABLED
  const eligibleSearch = enabled && config.BRAND === 'luxuryescapes' && !isBot &&
    (!filters.sortBy || filters.sortBy === 'recommended')
  const [interactions, fetching] = useUserInteractions({
    interactionType: 'view',
    sinceDaysAgo: TWO_TOWERS_INTERACTION_CUTOFF_DAYS,
    disabled: !eligibleSearch,
  })
  const eligible = eligibleSearch && !fetching && interactions.some(event => event.interaction === 'view')
  const { variation } = useExperiment(ChertoExperiments.searchRecommendationsReranking, {
    canActivate: eligible && !disabled,
  })

  return { rerankEligible: eligible && variation === 'variant', fetching }
}
